// Constant
import {
  RECEIVE_SMS_AUTH_CODE_REQUEST,
  SEND_SMS_REQUEST,
  UPDATE_AUTHENTICATION_CODE_DATA
} from '../../../modules/actions'
import {history} from "../../../store/configureStore";
import auth from "../../../modules/auth";

const initialState = {
  phoneNumber: '',
  authenticationCode: '',
  errors: {},
}

// Action handler
export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_AUTHENTICATION_CODE_DATA:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export const sendSMSRequest = ({info, successCallback, failCallback}) => ({
  type: SEND_SMS_REQUEST,
  info,
  successCallback,
  failCallback
})
export const receiveSMSAuthCodeRequest = ({info, successCallback, failCallback}) => ({
  type: RECEIVE_SMS_AUTH_CODE_REQUEST,
  info,
  successCallback,
  failCallback
})
export const updateAuthenticationCodeConfirmationSettings = (payload) => ({
  type: UPDATE_AUTHENTICATION_CODE_DATA,
  payload
})

// Actions
export const resendSMS = (phoneNumber) => {
  return (dispatch, getState) => {
    let info = {
      customer_info: {
        phone_number: phoneNumber
      }
    }
    dispatch(sendSMSRequest({
      info: info,
      successCallback: (data) => {},
      failCallback: (response) => {}
    }))
  }
}

export const receiveAuthCode = (authenticationCode) => {
  return (dispatch, getState) => {
    let info = {
      customer_info: {
        authentication_code: authenticationCode
      }
    }

    dispatch(receiveSMSAuthCodeRequest({
      info: info,
      successCallback: (data) => {
        if (data.customer) {
          auth.updateCustomerInfo(data.customer)
        }
        return history.push('/reports')
      },
      failCallback: (response) => {
        return dispatch(signupReceiveAuthCodeFailResponse(response))
      }
    }))
  }
}

export const signupReceiveAuthCodeFailResponse = (response) => {
  return (dispatch) => {
    const errors = {
      authenticationCode: '認証コードの認証に失敗しました。'
    }

    dispatch(updateAuthenticationCodeConfirmationSettings({
      errors: errors
    }))
  }
}




// WEBPACK FOOTER //
// ./src/routes/authenticationCodeConfirmation/modules/authenticationCodeConfirmation.js